module.exports = __webpack_public_path__ + "static/Julia-d385f0d4b1981175fcb6b0cd73d912d2.png";